import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { GetUserByIdFailure, GetUserByIdRequest, GetUserByIdSuccess } from './actions';
import { GetUserByIdService } from './service';

@Injectable()
export class GetUserByIdEffects {
  private readonly actions$ = inject(Actions);
  private readonly getUserByIdService = inject(GetUserByIdService);

  getUserById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetUserByIdRequest),
      switchMap(({ parameters }) =>
        this.getUserByIdService.getUserById(parameters).pipe(
          map(data => GetUserByIdSuccess({ data })),
          catchError(error => of(GetUserByIdFailure({ error })))
        )
      )
    )
  );

}
